window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const megaMenuContent = document.querySelector('.mega-menu__content');
        const nav = document.querySelector('.header__inline-menu');

        if (nav) {
            nav.style.visibility = 'visible';
        }
        if (megaMenuContent) {
            megaMenuContent.style.visibility = 'visible';
        }
    }, 300); // Delay in milliseconds (300ms = 0.3 seconds)
});
